
import { Link } from 'react-router-dom';

interface LegalHeroProps {
  title: string;
  subtitle: string;
}

export default function LegalHero({ title, subtitle }: LegalHeroProps) {
  return (
    <section className="relative min-h-[40vh] flex items-center justify-center overflow-hidden pt-24 pb-12">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url("https://public.readdy.ai/ai/img_res/1adc68b93d2f9f0da480dcd39fe49066.jpg")'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 w-full text-center">
        <nav className="flex items-center justify-center gap-2 text-sm text-neutral-400 mb-8">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">Inicio</Link>
          <i className="ri-arrow-right-s-line text-neutral-600"></i>
          <span className="text-white">{title}</span>
        </nav>

        <h1
          className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-4"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '3px' }}
        >
          {title}
        </h1>
        <p className="text-neutral-300 text-base md:text-lg max-w-xl mx-auto">
          {subtitle}
        </p>
      </div>
    </section>
  );
}
